<template>
    <v-app pb-3>
        <v-content>
            <v-form @submit.prevent="uploadFile">
                <v-container style="max-width: 600px">
                    <!-- Кастомный инпут для файлов -->
                    <div @click="triggerFileInput" style="cursor: pointer">
                        <v-text-field
                            label="Выберите файл"
                            prepend-icon="attach_file"
                            :value="fileName"
                            readonly
                            :error-messages="fileError"
                        ></v-text-field>
                    </div>

                    <!-- Скрытый инпут ВНЕ v-text-field -->
                    <input
                        type="file"
                        ref="fileInput"
                        style="display: none"
                        accept=".xlsx,.xls,.csv"
                        @change="handleFileSelect"
                    >

                    <div v-if="selectedFile" class="file-info">
                        <div>Файл: {{ selectedFile.name }}</div>
                        <div>Размер: {{ formatFileSize(selectedFile.size) }}</div>
                    </div>

                    <v-btn 
                        type="submit"
                        color="primary"
                        :disabled="!selectedFile || isLoading"
                        :loading="isLoading"
                    >
                        Загрузить
                        <template v-slot:loader>
                            <v-progress-circular indeterminate size="24"></v-progress-circular>
                        </template>
                    </v-btn>
                </v-container>
            </v-form>
        </v-content>
    </v-app>
</template>

<script>
export default {
    name: 'BankingProductsLoadFile',
    data: () => ({
        selectedFile: null,
        fileName: '',
        isLoading: false,
        fileError: ''
    }),
    methods: {
        triggerFileInput() {
            this.$nextTick(() => {
                this.$refs.fileInput.click();
            });
        },
        handleFileSelect(e) {
            const file = e.target.files[0];
            if (file) {
                this.selectedFile = file;
                this.fileName = file.name;
            }
        },

        async uploadFile() {
            if (!this.selectedFile) return;

            const formData = new FormData();
            formData.append('file', this.selectedFile);

            try {
                this.isLoading = true;
                
                // Показываем уведомление о начале загрузки
                if (window.PNotify) {
                    new window.PNotify({
                        title: 'Загрузка файла',
                        text: 'Идет обработка файла...',
                        type: 'info',
                        hide: false,
                        icon: false,
                        delay: 2000
                    });
                }

                const response = await axios.post('/bp/load-file', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });

                // Успешная загрузка
                    PNotify.success({
                        title: 'Успешно!',
                        text: response.data.message || 'Файл успешно загружен',
                        delay: 3000
                    });

                // Сброс состояния
                this.selectedFile = null;
                this.fileName = '';
                this.$refs.fileInput.value = '';

            } catch (error) {
                // Обработка ошибки
                const message = error.response.data.message 
                    || 'Ошибка при загрузке файла';
                
                    PNotify.error({
                        title: 'Ошибка загрузки',
                        text: message,
                        delay: 5000
                    });

                console.error('Upload error:', error);
            } finally {
                this.isLoading = false;
            }
        },

        formatFileSize(bytes) {
            if (bytes === 0) return '0 Bytes';
            const k = 1024;
            const sizes = ['Bytes', 'KB', 'MB'];
            const i = Math.floor(Math.log(bytes) / Math.log(k));
            return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
        }
    }
}
</script>

<style scoped>
.file-info {
    margin: 10px 0;
    padding: 10px;
    border: 1px solid #eee;
    border-radius: 4px;
    background-color: #f8f8f8;
}

.v-btn {
    margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/bank-products/BankingProductsLoadFile.vue